import * as types from './action-types';

const initialState = {
  fetchingDrivers: false,
  fetchingDriverAllocationDetails: false,
  driverAllocationDetails: {},
  fetchingDriverDetails: false,
  driverDetails: {},
  driverList: [],
  totalDrivers: 0,
  currentPage: 0
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {

    /** ACTION TYPES FOR DRIVER ALLOCATIONS START */
    case `${types.FETCH_DRIVER_ALLOCATIONS}_PENDING`: 
      return Object.assign({}, state, {
        fetchingDrivers: true
      });

    case `${types.FETCH_DRIVER_ALLOCATIONS}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingDrivers: false,
        driverList: action.payload.data.Details,
        totalDrivers: action.payload.data.Total
      });

    case `${types.FETCH_DRIVER_ALLOCATIONS}_REJECTED`:
      return {
        isRejected: true,
        error: 'Get Driver Allocation Failed'
      };

    /** ACTION TYPES FOR DRIVER ALLOCATION DETAILS START**/
    case `${types.FETCH_DRIVER_ALLOCATION_DETAILS}_PENDING`:
      return Object.assign({}, state, {
        fetchingDriverAllocationDetails: true,
        driverAllocationDetails: {}
      });
    case `${types.FETCH_DRIVER_ALLOCATION_DETAILS}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingDriverAllocationDetails: false,
        driverAllocationDetails: action.payload.data
      });
      case `${types.FETCH_DRIVER_ALLOCATION_DETAILS}_REJECTED`:
      return {
        isRejected: true,
        error: 'Get Driver Allocation Details Failed'
      };  
    /** ACTION TYPES FOR DRIVER ALLOCATION DETAILS END**/

    /** ACTION TYPES FOR DRIVER DETAILS START**/
    case `${types.FETCH_DRIVER_DETAILS}_PENDING`:
      return Object.assign({}, state, {
        fetchingDriverDetails: true,
        driverDetails: {}
      });
    case `${types.FETCH_DRIVER_DETAILS}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingDriverDetails: false,
        driverDetails: action.payload.data
      });
      case `${types.FETCH_DRIVER_DETAILS}_REJECTED`:
      return {
        isRejected: true,
        error: 'Get Driver Details Failed' 
      };  
    /** ACTION TYPES FOR DRIVER DETAILS END**/

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/reducer.js